import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";

export class WalkOfShameIntroConfig implements GameIntroViewConfig {

    public colors: GameIntroColors = {
        slideShowColors: {
            backgroundColor: 0x000000, //Default 0x000000
            backgroundAlpha: 0.7, //Default 0.4
            bulletColor: 0xffffff //Default 0xffffff
        },
        stampColor: 0xFFFFFF
    };

    public stampConfig: StampConfig = {
        volatility: Volatility.MEDIUM,
        xSplit: true
    };

    public background: PIXI.Container;
    public borderBottom: PIXI.Container;
    public borderTop: PIXI.Container;
    public logo: PIXI.Container;
    public pages: SlideShowPage[];

    constructor() {
    }

    public init(): Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add("introBg", "resources/images/Intro_BG.jpg");
        imgLoader.add("feature1", "resources/images/intro_feature1.png");
        imgLoader.add("feature2", "resources/images/intro_feature2.png");
        imgLoader.add("feature3", "resources/images/intro_feature3.png");
        imgLoader.add("feature4", "resources/images/intro_feature4.png");
        imgLoader.add("logo", "resources/images/introLogo.png");

        return imgLoader.load().then(() => {
            this.initGraphics();
            return this;
        });
    }

    private initGraphics(): void {
        this.background = new PIXI.Container();
        const bgSprite: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("introBg"));
        bgSprite.anchor.set(0.5, 0.5);
        this.background.addChild(bgSprite);

        this.borderTop = new PIXI.Container();

        this.borderBottom = new PIXI.Container();

        this.logo = new PIXI.Container();
        const logoSprite: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("logo"));
        logoSprite.anchor.set(0.5, 0.5);
        this.logo.addChild(logoSprite);

        this.pages = [
            new SlideShowPage(ImgLoader.getImgTexture("feature1"), ""),
            new SlideShowPage(ImgLoader.getImgTexture("feature2"), ""),
            new SlideShowPage(ImgLoader.getImgTexture("feature4"), ""),
            new SlideShowPage(ImgLoader.getImgTexture("feature3"), "")
        ];

        this.pages.forEach((page: SlideShowPage) => {
            (page.children[0] as PIXI.Sprite).anchor.x = 0.5;
        });
    }
}